"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { Minus, Plus } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={cn("rounded-xl overflow-hidden bg-white", className)} {...props} />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "rounded-2xl group flex flex-1 items-center justify-between px-4 py-3.5 md:px-6 md:py-5 md:text-lg font-medium transition-colors text-left cursor-pointer",
        "text-title data-[state=open]:bg-primary data-[state=open]:text-white",
        className
      )}
      {...props}
    >
      {children}
      <span className="shrink-0 ml-2 md:ml-4 flex items-center justify-center size-7 md:size-10 rounded-full group-data-[state=open]:bg-white">
        <Plus className="size-3.5 md:size-5 text-primary block group-data-[state=open]:hidden" strokeWidth={2.5} />
        <Minus className="size-3.5 md:size-5 text-primary hidden group-data-[state=open]:block" strokeWidth={2.5} />
      </span>
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn("px-6 pb-8 pt-6", className)}>{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
